import { deleteSubjectUseCase } from '@src/main/modules/messages/application/use-cases/delete/delete-subject.usecase';
import { createSubjectHttpRepository } from '@src/main/modules/messages/infrastructure/repository/SubjectHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useDeleteSubject = () => {
  const { user } = useAuth();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createSubjectHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useMutation({
    mutationFn: async (id: string) => {
      if (!repository) throw new Error('Repository not initialized');
      return await deleteSubjectUseCase(id, tokenProvider);
    },
  });
};
